export default {
  "club_currency_not_configured": "Club currency not configured",
  "please_configure_a_currency_in_control_to_view_cost_comparisons": "Please configure a currency in Control to view cost comparisons.",
  "currency_lookup_failed": "Currency lookup failed",
  "defaulted_to_gbp_until_the_currency_service_is_available": "Defaulted to GBP until the currency service is available.",
  "failed_to_load_budgets": "Failed to load budgets",
  "failed_to_load_budget_references": "Failed to load budget references",
  "sent_to_budget": "Sent to Budget",
  "budget_line_created_for_board_approval": "Budget line created for board approval.",
  "failed_to_send_to_budget": "Failed to send to budget",
  "failed_to_award_rfq": "Failed to award RFQ",
  "cost_advantage": "Cost advantage",
  "quality_advantage": "Quality advantage",
  "service_advantage": "Service advantage",
  "head_to_head_bidder_battle": "Head-to-Head Bidder Battle",
  "select_rfq_to_compare": "Select RFQ to compare",
  "cost_weight": "Cost Weight",
  "quality_weight": "Quality Weight",
  "service_weight": "Service Weight",
  "total_weight": "Total weight:",
  "total_weight_must_be_100_currently": "Total weight must be ≤ 100%. Currently",
  "reduce_by": "% (reduce by",
  "reset_to_template": "Reset to template",
  "set_at_least_one_weight_above_0_to_run_the_comparison": "Set at least one weight above 0% to run the comparison.",
  "calculating": "Calculating...",
  "run_battle_analysis": "Run Battle Analysis",
  "calculating_battle_outcome": "Calculating battle outcome...",
  "winner": "Winner",
  "tie": "Tie",
  "lead_margin": "Lead Margin",
  "biggest_differentiator": "Biggest Differentiator",
  "challenger_a": "Challenger A",
  "winner_32": "WINNER",
  "tie_33": "TIE",
  "total_cost": "Total Cost",
  "final_score_10": "Final Score (/10)",
  "evaluate": "Evaluate",
  "cost_score": "Cost Score:",
  "quality_score": "Quality Score:",
  "service_score": "Service Score:",
  "unknown": "Unknown",
  "send_to_budget": "Send to Budget",
  "awarding": "Awarding...",
  "award": "Award",
  "this_rfq_was_sent_to_budget_with_a_different_bid": "This RFQ was sent to budget with a different bid.",
  "challenger_b": "Challenger B",
  "awaiting_submissions": "Awaiting Submissions",
  "awaiting_more_bidder_submissions_for_this_rfq": "Awaiting more bidder submissions for this RFQ.",
  "category_breakdown": "Category Breakdown",
  "quality_score_49": "Quality Score",
  "service_score_50": "Service Score",
  "ready_for_battle": "Ready for Battle!",
  "no_submissions_available_yet_for_the_selected_rfq": "No submissions available yet for the selected RFQ.",
  "select_an_rfq_with_multiple_submissions_to_start_the_head_to_head": "Select an RFQ with multiple submissions to start the head-to-head comparison",
  "no_rfqs_available": "No RFQs available",
  "there_are_no_rfqs_to_compare_please_create_or_import_rfqs_to_use_": "There are no RFQs to compare. Please create or import RFQs to use this feature.",
  "award_without_board_approval": "Award without board approval?",
  "are_you_sure_board_approval_is_not_required_for_awarding_this_bid": "Are you sure board approval is not required for awarding this bid? This action will be logged.",
  "cancel": "Cancel",
  "yes_award_anyway": "Yes, award anyway",
  "select_an_existing_budget_to_create_a_board_approved_earmark": "Select an existing budget to create a board-approved earmark.",
  "budget": "Budget",
  "no_budgets_available": "No budgets available",
  "gl_account": "GL Account",
  "department": "Department",
  "owner_optional": "Owner (optional)",
  "search_staff_by_name_or_email": "Search staff by name or email",
  "unassigned": "Unassigned",
  "searching": "Searching...",
  "no_matches": "No matches",
  "type_at_least_2_characters_to_search": "Type at least 2 characters to search.",
  "searching_staff": "Searching staff...",
  "select_a_staff_member_to_assign_ownership": "Select a staff member to assign ownership.",
  "category": "Category",
  "total_amount": "Total amount",
  "currency": "Currency:",
  "month_allocation": "Month allocation",
  "single_month_charge": "Single month charge",
  "split_across_months": "Split across months",
  "month": "Month",
  "amount": "Amount",
  "remove": "Remove",
  "add_month": "Add month",
  "allocated_total": "Allocated total:",
  "allocation_total_must_match_the_total_amount": "Allocation total must match the total amount.",
  "sending": "Sending...",
  "contract_renewal_alerts": "Contract Renewal Alerts",
  "ai_powered_contract_renewal_predictions_and_recommendations": "AI-powered contract renewal predictions and recommendations",
  "critical": "Critical",
  "refresh": "Refresh",
  "upcoming_renewals": "Upcoming Renewals",
  "next_30_days": "Next 30 days",
  "critical_risk": "Critical Risk",
  "require_attention": "Require attention",
  "total_value": "Total Value",
  "annual_contracts": "Annual contracts",
  "avg_performance": "Avg Performance",
  "out_of_100": "out of 100",
  "all_contracts": "All Contracts",
  "risk": "Risk",
  "contract": "Contract",
  "contract_ends": "Contract Ends",
  "days_to_decide": "days to decide",
  "current_value": "Current Value",
  "predicted_increase": "% predicted increase",
  "performance_score": "Performance Score",
  "alternatives": "Alternatives",
  "bidders": "bidders",
  "ai_recommendation": "AI Recommendation:",
  "risk_factors": "Risk Factors:",
  "last_review": "Last Review:",
  "start_negotiation": "Start Negotiation",
  "schedule_review": "Schedule Review",
  "no_contract_renewals": "No Contract Renewals",
  "no_contracts_match_the_selected_risk_level": "No contracts match the selected risk level.",
  "usda_market_news": "USDA Market News",
  "food_agricultural_commodities": "Food & agricultural commodities",
  "eia_energy_data": "EIA Energy Data",
  "fuel_prices_and_energy_costs": "Fuel prices and energy costs",
  "bureau_of_labor_statistics": "Bureau of Labor Statistics",
  "cpi_ppi_indices_for_service_categories": "CPI/PPI indices for service categories",
  "wine_searcher": "Wine-Searcher",
  "global_wine_pricing_database": "Global wine pricing database",
  "liv_ex": "Liv-ex",
  "fine_wine_trading_platform": "Fine wine trading platform",
  "mintec": "Mintec",
  "food_ingredient_pricing": "Food ingredient pricing",
  "opis": "OPIS",
  "intraday_fuel_pricing": "Intraday fuel pricing",
  "price_index_data_sources": "Price Index Data Sources",
  "core_data_sources": "Core Data Sources",
  "included": "Included",
  "updates": "Updates:",
  "enhanced_data_sources": "Enhanced Data Sources",
  "available": "Available",
  "premium_feature": "Premium Feature",
  "enhanced_data_sources_provide_deeper_market_intelligence_with_rea": "Enhanced data sources provide deeper market intelligence with real-time pricing, specialty categories, and advanced analytics. Contact your Privana representative to enable these premium feeds.",
  "data_sources_update_automatically_changes_take_effect_within_1_ho": "Data sources update automatically. Changes take effect within 1 hour.",
  "save_settings": "Save Settings",
  "failed_to_load_bidders": "Failed to load bidders",
  "all_bidders": "All Bidders",
  "master_directory_of_vendors_across_all_rfqs": "Master directory of vendors across all RFQs",
  "search_by_name_or_email": "Search by name or email",
  "status": "Status",
  "all": "All",
  "active": "Active",
  "inactive": "Inactive",
  "name": "Name",
  "contact": "Contact",
  "email": "Email",
  "website": "Website",
  "phone": "Phone",
  "last_updated": "Last Updated",
  "loading_bidders": "Loading bidders...",
  "no_bidders_found": "No bidders found.",
  "showing_0_bidders": "Showing 0 bidders",
  "previous": "Previous",
  "next": "Next",
  "active_rfqs": "Active RFQs",
  "data_unavailable": "Data unavailable",
  "total_submissions": "Total Submissions",
  "submitted_bids": "submitted bids",
  "club_currency": "club currency",
  "avg_response_time": "Avg Response Time",
  "to_submission": "to submission",
  "cost_savings_vs_budget": "Cost Savings vs Budget",
  "weighted_across_rfqs": "weighted across RFQs",
  "urgent_rfqs": "Urgent RFQs",
  "no_urgent_rfqs": "No urgent RFQs",
  "no_deadline": "No deadline",
  "recent_activity": "Recent Activity",
  "no_recent_activity": "No recent activity",
  "rfq_processing_time": "RFQ Processing Time",
  "average_response_time": "average response time",
  "bidder_participation": "Bidder Participation",
  "avg_submissions_per_rfq": "avg submissions per RFQ",
  "cost_savings": "Cost Savings",
  "vs_budgeted_amounts": "vs budgeted amounts",
  "bidder_performance_heatmap": "Bidder Performance Heatmap",
  "high_risk_only": "High Risk Only",
  "medium_risk_only": "Medium Risk Only",
  "low_risk_only": "Low Risk Only",
  "avg_lead_time": "Avg Lead Time",
  "days": "days",
  "avg_price_variance": "Avg Price Variance",
  "avg_reliability": "Avg Reliability",
  "high_risk": "High Risk",
  "risk_188": "risk",
  "lead_time": "Lead Time:",
  "price_variance": "Price Variance:",
  "reliability": "Reliability:",
  "sla_breaches": "SLA Breaches:",
  "risk_193": "Risk:",
  "heat_score": "Heat Score:",
  "no_bidder_data": "No Bidder Data",
  "click_generate_demo_data_to_see_bidder_locations_and_performance_": "Click \"Generate Demo Data\" to see bidder locations and performance metrics",
  "legend": "Legend",
  "low_risk_bidders": "Low Risk Bidders",
  "medium_risk_bidders": "Medium Risk Bidders",
  "high_risk_bidders": "High Risk Bidders",
  "circle_size_indicates_heat_score_larger_higher_risk_variance": "Circle size indicates heat score (larger = higher risk/variance)",
  "new_procurement_request": "New Procurement Request",
  "request_title": "Request Title *",
  "brief_description_of_what_you_need": "Brief description of what you need",
  "detailed_description": "Detailed Description *",
  "provide_detailed_requirements_specifications_quantities_etc": "Provide detailed requirements, specifications, quantities, etc.",
  "your_department": "Your department",
  "select_category": "Select category",
  "products": "Products",
  "services": "Services",
  "maintenance": "Maintenance",
  "technology": "Technology",
  "food_beverage": "Food & Beverage",
  "other": "Other",
  "estimated_budget": "Estimated Budget",
  "required_by_date": "Required By Date",
  "urgency": "Urgency",
  "low": "Low",
  "medium": "Medium",
  "high": "High",
  "urgent": "Urgent",
  "submit_request": "Submit Request",
  "unable_to_generate_rfq": "Unable to generate RFQ",
  "ai_powered_rfq_builder": "AI-Powered RFQ Builder",
  "describe_your_procurement_need": "Describe Your Procurement Need",
  "what_do_you_need_be_as_specific_as_possible": "What do you need? (Be as specific as possible)",
  "e_g_we_need_a_weekly_linen_service_for_our_dining_room_including_": "e.g., 'We need a weekly linen service for our dining room, including tablecloths, napkins, and kitchen towels. We serve about 300 covers per week and need premium quality with same-day stain removal guarantee...'",
  "ai_will_help_you_with": "AI will help you with:",
  "professional_rfq_structure_and_language": "• Professional RFQ structure and language",
  "industry_specific_requirements_and_compliance": "• Industry-specific requirements and compliance",
  "evaluation_criteria_recommendations": "• Evaluation criteria recommendations",
  "contract_terms_suggestions": "• Contract terms suggestions",
  "line_item_specifications": "• Line item specifications",
  "ai_generated_rfq_review_edit": "AI Generated RFQ - Review & Edit",
  "title": "Title",
  "description": "Description",
  "urgent_rfq": "Urgent RFQ",
  "flag_for_expedited_procurement_review": "Flag for expedited procurement review.",
  "link_budget_line_staff_only": "Link Budget Line (staff only)",
  "clear_selection": "Clear selection",
  "budget_amounts_remain_hidden_from_bidders": "Budget amounts remain hidden from bidders.",
  "line_items": "Line Items",
  "add_item": "Add Item",
  "item_name": "Item Name",
  "unit_of_measure": "Unit of Measure",
  "e_g_each_kg_hours": "e.g., each, kg, hours",
  "quantity": "Quantity",
  "est_unit_cost": "Est. Unit Cost ($)",
  "specifications": "Specifications",
  "detailed_specifications_quality_requirements_etc": "Detailed specifications, quality requirements, etc.",
  "rfq_summary": "RFQ Summary",
  "urgent_252": "Urgent:",
  "yes": "Yes",
  "budget_line": "Budget line:",
  "line_items_255": "Line Items (",
  "generating": "Generating...",
  "generate_rfq": "Generate RFQ",
  "review_publish": "Review & Publish",
  "create_rfq": "Create RFQ",
  "cost": "Cost",
  "quality": "Quality",
  "service": "Service",
  "failed_to_load_rfq": "Failed to load RFQ",
  "please_configure_a_currency_in_control_before_creating_submission": "Please configure a currency in Control before creating submissions.",
  "bidder_invited_no_email_sent": "Bidder invited (no email sent)",
  "invite_created_email_failed": "Invite created (email failed)",
  "failed_to_invite_bidder": "Failed to invite bidder",
  "bidder_name_is_required": "Bidder name is required",
  "failed_to_create_bidder": "Failed to create bidder",
  "status_updated": "Status updated",
  "failed_to_update_status": "Failed to update status",
  "scoring_template_updated": "Scoring template updated",
  "failed_to_update_scoring_template": "Failed to update scoring template",
  "enter_scores_before_saving": "Enter scores before saving",
  "evaluation_saved": "Evaluation saved",
  "failed_to_save_evaluation": "Failed to save evaluation",
  "select_a_bidder_first": "Select a bidder first",
  "please_configure_a_currency_before_creating_submissions": "Please configure a currency before creating submissions.",
  "submission_saved": "Submission saved",
  "failed_to_save_submission": "Failed to save submission",
  "failed_to_promote_supplier": "Failed to promote supplier",
  "portal_link_copied": "Portal link copied",
  "failed_to_copy_portal_link": "Failed to copy portal link",
  "portal_link_regenerated": "Portal link regenerated",
  "failed_to_regenerate_link": "Failed to regenerate link",
  "failed_to_send_invite_email": "Failed to send invite email",
  "rfq_detail": "RFQ Detail",
  "back_to_list": "Back to list",
  "loading_rfq_details": "Loading RFQ details...",
  "rfq_not_found": "RFQ not found.",
  "uncategorized": "Uncategorized",
  "created": "· Created",
  "invited": "· Invited",
  "submitted": "· Submitted",
  "overview": "Overview",
  "bidders_296": "Bidders",
  "submissions": "Submissions",
  "evaluation": "Evaluation",
  "activity": "Activity",
  "deadline": "Deadline:",
  "type": "Type",
  "set_status": "Set status",
  "awarded": "Awarded",
  "awarded_bidder": "Awarded bidder",
  "view_supplier": "View Supplier",
  "promote_to_supplier": "Promote to Supplier",
  "award_this_rfq_to_promote_the_winning_bidder_into_the_suppliers_m": "Award this RFQ to promote the winning bidder into the Suppliers module.",
  "invited_bidders": "Invited Bidders",
  "invited_309": "invited",
  "search_bidders": "Search bidders",
  "invite": "Invite",
  "add_a_new_bidder": "Add a new bidder",
  "bidder_name": "Bidder name",
  "email_optional": "Email (optional)",
  "create_invite": "Create & Invite",
  "no_bidders_invited_yet": "No bidders invited yet.",
  "status_317": "Status:",
  "submitted_318": "Submitted",
  "more_details": "More details",
  "last_viewed": "Last viewed",
  "link_expires": "Link expires",
  "revoked": "This invitation link has been revoked. Please request a new link from the club.",
  "invite_email_sent": "Invite email sent",
  "invite_email_failed": "Invite email failed:",
  "submission_confirmation_sent": "Submission confirmation sent",
  "submission_confirmation_failed": "Submission confirmation failed:",
  "copy_link": "Copy link",
  "regenerate_link": "Regenerate link",
  "send_invite_email": "Send invite email",
  "received": "received",
  "bidder": "Bidder",
  "select_invited_bidder": "Select invited bidder",
  "notes": "Notes",
  "currency_334": "Currency",
  "club_currency_not_configured_submissions_are_disabled": "Club currency not configured. Submissions are disabled.",
  "upload_quote_pdf": "Upload quote (PDF)",
  "saving": "Saving...",
  "save_submission": "Save Submission",
  "no_submissions_yet": "No submissions yet.",
  "awarded_bid": "Awarded Bid",
  "no_notes": "No notes",
  "view": "View",
  "scoring_template": "Scoring Template",
  "weight": "Weight (%)",
  "save_template": "Save template",
  "weights_must_add_up_to_100": "Weights must add up to 100%.",
  "no_submissions_available_to_evaluate": "No submissions available to evaluate.",
  "total_score": "Total score:",
  "needs_evaluation": "Needs evaluation",
  "cost_rating_0_10": "Cost rating (0–10)",
  "quality_rating_0_10": "Quality rating (0–10)",
  "service_rating_0_10": "Service rating (0–10)",
  "save_evaluation": "Save evaluation",
  "requires_board_approved_budget": "Requires board-approved budget.",
  "computed_total": "Computed total:",
  "linked_to_budget": "Linked to budget",
  "no_budget_linked_yet_use_evaluation_to_send_a_bid_to_budget": "No budget linked yet. Use Evaluation to send a bid to Budget.",
  "no_activity_yet": "No activity yet.",
  "this_will_create_a_supplier_record_from_the_awarded_bidder_and_li": "This will create a Supplier record from the awarded bidder and link it to this RFQ.",
  "also_create_a_contract_for_renewals": "Also create a contract for renewals",
  "optional_contract_details_will_be_attached_to_the_new_supplier": "Optional contract details will be attached to the new supplier.",
  "contract_name": "Contract name",
  "start_date": "Start date",
  "end_date": "End date",
  "renewal_type": "Renewal type",
  "notice_period_days": "Notice period days",
  "value": "Value",
  "promoting": "Promoting...",
  "confirm": "Confirm",
  "submission": "Submission",
  "previous_371": "← Previous",
  "of": "of",
  "next_373": "Next →",
  "pricing_summary": "Pricing Summary",
  "lead_time_375": "Lead Time",
  "validity_date": "Validity Date",
  "no_notes_provided": "No notes provided.",
  "exclusions": "Exclusions",
  "assumptions": "Assumptions",
  "attachments": "Attachments",
  "copy_bidder_portal_link": "Copy bidder portal link",
  "download": "Download",
  "no_files_attached": "No files attached.",
  "last_updated_384": "Last updated",
  "failed_to_load_rfqs": "Failed to load RFQs",
  "rfq_status_updated": "RFQ status updated",
  "requests_for_quotation_rfqs": "Requests for Quotation (RFQs)",
  "loading_rfqs": "Loading RFQs...",
  "invited_389": "Invited:",
  "submitted_390": "Submitted:",
  "created_391": "Created:",
  "invite_more_bidders": "Invite More Bidders",
  "send_to_bidders": "Send to Bidders",
  "view_details": "View Details",
  "change_status": "Change status",
  "no_rfqs_found": "No RFQs found.",
  "real_time_price_index": "Real-Time Price Index",
  "live_usda_food_commodity_pricing_and_bidder_comparisons": "Live USDA food commodity pricing and bidder comparisons",
  "usda_live_data": "USDA Live Data",
  "updating": "Updating...",
  "price_index_enhanced_coming_soon": "Price Index Enhanced coming soon",
  "more_categories_with_premium_data_feeds_fuel_linens_wine_technolo": "- More categories with premium data feeds (fuel, linens, wine, technology).",
  "price_alerts": "price alerts:",
  "significant_price_movements_detected_in": "Significant price movements detected in",
  "5_week_trend_flow": "5-Week Trend Flow",
  "select_an_item_below_to_view_its_5_week_price_trend": "Select an item below to view its 5-week price trend.",
  "all_categories": "All Categories",
  "no_live_data": "No live data",
  "vs": "vs $",
  "vs_club_actual": "vs Club Actual",
  "club_pays": "Club pays: $",
  "volatility": "Volatility",
  "awaiting_next_usda_update": "Awaiting next USDA update",
  "data_sources_schedule": "Data Sources & Schedule:",
  "usda_market_news_service": "USDA Market News Service",
  "last_updated_416": "Last updated:",
  "next_update": "Next update:",
  "updates_automatically_every_monday_at_8_00_am_local_time_or_click": "Updates automatically every Monday at 8:00 AM local time, or click Refresh for immediate update.",
  "enhanced_available": "Enhanced Available",
  "contact_support_for_fuel_wine_linens_more": "Contact support for fuel, wine, linens & more",
  "no_usda_price_data_available": "No USDA Price Data Available",
  "click_refresh_to_load_current_usda_commodity_pricing_data": "Click refresh to load current USDA commodity pricing data.",
  "load_usda_data": "Load USDA Data",
  "unable_to_prepare_invitation_emails": "Unable to prepare invitation emails",
  "review_bidder_emails": "Review bidder emails",
  "source": "Source",
  "existing_bidder": "Existing bidder",
  "new_bidder": "New bidder",
  "search_all_bidders": "Search All Bidders",
  "type_at_least_2_characters": "Type at least 2 characters",
  "no_email": "no email",
  "company_name": "Company name",
  "contact_first_name": "Contact first name",
  "contact_last_name": "Contact last name",
  "existing_bidder_contact_details_are_read_only_here_edit_the_canon": "Existing bidder contact details are read-only here. Edit the canonical record in All Bidders before preparing this invitation.",
  "this_bidder_or_email_is_already_selected": "This bidder or email is already selected.",
  "add_bidder": "Add bidder",
  "your_microsoft_mailbox_is_not_available_connect_or_reconnect_it_i": "Your Microsoft mailbox is not available. Connect or reconnect it in Communications before sending. Privana will not fall back to system email.",
  "generating_drafts_creates_the_canonical_rfq_bidder_relationship_s": "Generating drafts creates the canonical RFQ–bidder relationship, so the Invited count may increase before email is sent. Draft, sent, and failed delivery states remain tracked separately.",
  "generate_email_drafts": "Generate email drafts",
  "from": "From",
  "to": "To",
  "recipient_is_tied_to_the_selected_canonical_bidder_contact_edit_t": "Recipient is tied to the selected canonical bidder contact. Edit the bidder in All Bidders to change it.",
  "subject": "Subject",
  "body": "Body",
  "include_online_quote_submission_link": "Include online quote submission link",
  "adds_a_secure_privana_link_to_this_email_so_the_bidder_can_submit": "Adds a secure Privana link to this email so the bidder can submit their quotation directly into this RFQ. Turn this off if you want the bidder to reply or send their quotation to you by email instead.",
  "retry_this_recipient": "Retry this recipient",
  "reconciliation_pending": "reconciliation pending",
  "recheck_delivery": "Recheck delivery",
  "send_this_email": "Send this email",
  "sent": "sent",
  "close": "Close",
  "retry_unsent_recipients": "Retry unsent recipients",
  "send_all_emails": "Send all emails",
  "professional": "Professional",
  "formal_and_business_like": "Formal and business-like",
  "friendly": "Friendly",
  "warm_and_collaborative": "Warm and collaborative",
  "stern": "Stern",
  "firm_and_direct": "Firm and direct",
  "diplomatic": "Diplomatic",
  "tactful_and_careful": "Tactful and careful",
  "video_call": "Video Call",
  "phone_call": "Phone Call",
  "in_person_meeting": "In-Person Meeting",
  "start_negotiation_469": "Start Negotiation -",
  "schedule_review_470": "Schedule Review -",
  "recipients": "Recipients",
  "bidder_contacts": "Bidder Contacts",
  "primary": "Primary",
  "cc_staff_members": "CC Staff Members",
  "cc_custom_emails": "CC Custom Emails",
  "enter_email_address": "Enter email address",
  "email_content": "Email Content",
  "tone": "Tone",
  "meeting_type": "Meeting Type",
  "generate_ai_content": "Generate AI Content",
  "email_subject": "Email subject",
  "message": "Message",
  "compose_your_email_message": "Compose your email message...",
  "send_email": "Send Email",
  "bidder_portal": "Bidder Portal",
  "external_bidder_access_is_now_available": "External bidder access is now available.",
  "bidder_portal_enabled": "Bidder Portal Enabled",
  "external_bidder_access_is_enabled_from_rfq_detail_via_invite_link": "External bidder access is enabled from RFQ detail via invite links.",
  "jan": "Jan",
  "feb": "Feb",
  "mar": "Mar",
  "apr": "Apr",
  "may": "May",
  "jun": "Jun",
  "jul": "Jul",
  "aug": "Aug",
  "sep": "Sep",
  "oct": "Oct",
  "nov": "Nov",
  "dec": "Dec",
  "operating": "Operating",
  "capex": "CapEx",
  "select_gl_account": "Select GL account",
  "failed_to_load_procurement_data": "Failed to load procurement data",
  "failed_to_create_rfq": "Failed to create RFQ",
  "create_professional_rfqs_with_ai_assistance": "Create professional RFQs with AI assistance",
  "start_new_rfq": "Start New RFQ",
  "phase_1": "Phase 1",
  "missing_required_fields": "Missing required fields",
  "contact_name_email_total_amount_and_currency_are_required_to_subm": "Contact name, email, total amount, and currency are required to submit.",
  "submission_locked": "Submission locked",
  "this_offer_has_already_been_submitted_and_can_no_longer_be_edited": "This offer has already been submitted and can no longer be edited.",
  "deadline_passed": "Deadline passed",
  "the_submission_deadline_has_passed_please_contact_the_club": "The submission deadline has passed. Please contact the club.",
  "file_uploaded": "File uploaded",
  "file_upload_failed": "File upload failed",
  "loading_invitation": "Loading invitation...",
  "bidder_submission_portal": "Bidder Submission Portal",
  "request_for_quote": "Request for Quote",
  "category_520": "Category:",
  "type_521": "· Type:",
  "company": "Company:",
  "your_offer_is_locked_editing_is_unavailable": "Your offer is locked. Editing is unavailable.",
  "contact_name": "Contact name",
  "contact_email": "Contact email",
  "total_price": "Total price",
  "currency_is_not_configured_please_contact_the_club_before_submitt": "Currency is not configured. Please contact the club before submitting.",
  "lead_time_days": "Lead time (days)",
  "validity_until": "Validity until",
  "accepted_pdf_images_word_documents_or_text_files_max_10mb": "Accepted: PDF, images, Word documents, or text files (max 10MB).",
  "save_draft": "Save Draft",
  "submit_offer": "Submit Offer",
  "retry": "Please try again.",
  "serverError": "Server error",
  "budgetUnknown": "Budget status unknown (refresh).",
  "awardedOverride": "Awarded (override)",
  "rfqAwarded": "RFQ awarded",
  "budgetLoading": "Loading budgets...",
  "budgetSelect": "Select a budget",
  "budgetLinesLoading": "Loading budget lines…",
  "budgetLineSelect": "Select a budget line",
  "budgetLineSearch": "Search budget lines...",
  "budgetLineError": "Unable to load budget lines.",
  "budgetLinesEmpty": "No budget lines found.",
  "retryMoment": "Please try again in a moment.",
  "no": "No",
  "submittedSuccessfully": "Submitted successfully",
  "draftSaved": "Draft saved",
  "offerSubmitted": "Your offer has been submitted to the club.",
  "draftReturn": "You can return to update this draft anytime before the deadline.",
  "submissionFailed": "Submission failed",
  "draftFailed": "Draft save failed",
  "expired": "This invitation link has expired. Please request a new link from the club.",
  "invalid": "This invitation link is invalid or unavailable.",
  "reconciling": "Microsoft delivery is being reconciled. Privana will not resend until the provider outcome is known.",
  "sendFailed": "Send failed",
  "supplierLinked": "Supplier already linked",
  "supplierCreated": "Supplier created",
  "copied": "Link copied to clipboard.",
  "newCopied": "New link copied to clipboard.",
  "selectGl": "Select GL account",
  "searchGl": "Search GL accounts...",
  "emptyGl": "No GL accounts found.",
  "selectDepartment": "Select department",
  "searchDepartment": "Search departments...",
  "emptyDepartment": "No departments found.",
  "primaryContact": "Primary Contact",
  "selectRecipient": "Please select at least one bidder contact to send to.",
  "emailFailed": "Failed to send email. Please try again.",
  "enter": "Enter",
  "showing": "Showing {start}–{end} of {total} bidders",
  "daysValue": "{count} days",
  "due": "Due: {date}",
  "publishedActivity": "RFQ published: {title}",
  "submissionActivity": "Submission from {name}",
  "regenerateConfirm": "Regenerate the portal link for {name}? The previous link will stop working.",
  "expires": "Expires {date}",
  "newExpires": "New link expires {date}",
  "inviteEmailed": "Invite emailed to {recipient}",
  "toRecipient": " to {recipient}",
  "emailSent": "Email sent successfully to {count} recipients!",
  "negotiationSubject": "Contract Negotiation - {name}",
  "reviewSubject": "Contract Review Meeting - {name}",
  "portalUnavailable": "Bidder access is unavailable. Please contact the club.",
  "enums": {
    "status": {
      "draft": "Draft",
      "published": "Published",
      "collecting_quotes": "Collecting Quotes",
      "evaluation": "Evaluation",
      "awarded": "Awarded",
      "closed": "Closed",
      "cancelled": "Cancelled",
      "active": "Active",
      "inactive": "Inactive",
      "submitted": "Submitted",
      "invited": "Invited",
      "viewed": "Viewed",
      "pending": "Pending",
      "sent": "Sent",
      "failed": "Failed",
      "sending": "Sending",
      "reconciling": "Reconciling",
      "reconciliation_pending": "Reconciliation pending",
      "board_approved": "Board approved",
      "approved": "Approved",
      "open": "Open",
      "rejected": "Rejected",
      "expired": "Expired",
      "revoked": "Revoked",
      "reconciliation pending": "Reconciliation pending"
    },
    "risk": {
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "unknown": "Unknown"
    },
    "recommendation": {
      "renew": "Renew",
      "renegotiate": "Renegotiate",
      "replace": "Replace",
      "review": "Review"
    },
    "category": {
      "products": "Products",
      "services": "Services",
      "maintenance": "Maintenance",
      "technology": "Technology",
      "food_beverage": "Food & Beverage",
      "linen_laundry": "Linen & Laundry",
      "landscaping": "Landscaping",
      "security": "Security",
      "other": "Other",
      "Operating": "Operating",
      "CapEx": "CapEx"
    },
    "criterion": {
      "cost": "Cost",
      "quality": "Quality",
      "service": "Service"
    },
    "activity": {
      "RFQIssued": "RFQ issued",
      "RFQUpdated": "RFQ updated",
      "RFQSubmissionReceived": "Submission received",
      "RFQSubmissionEvaluated": "Submission evaluated",
      "RFQAwarded": "RFQ awarded",
      "portal_link_generated": "Portal link generated",
      "portal_link_regenerated": "Portal link regenerated",
      "created": "RFQ created",
      "updated": "RFQ updated",
      "status_changed": "Status changed",
      "bidder_invited": "Bidder invited",
      "bidder_invite_email_sent": "Bidder invitation email sent",
      "bidder_invitation_email_sent": "Bidder invitation email sent",
      "bidder_invitation_email_failed": "Bidder invitation email failed",
      "bidder_promoted_to_supplier": "Bidder promoted to supplier",
      "bidder_submission_file_uploaded": "Bidder attachment uploaded",
      "budget_link_removed": "Budget link removed",
      "rfq_awarded": "RFQ awarded",
      "rfq_awarded_without_board_approval": "RFQ awarded without board approval",
      "sent_to_budget": "Sent to Budget",
      "submission_created": "Offer created",
      "submission_evaluated": "Offer evaluated",
      "submission_file_uploaded": "Offer attachment uploaded"
    },
    "market": {
      "Beef": "Beef",
      "Pork": "Pork",
      "Poultry": "Poultry",
      "Dairy": "Dairy",
      "Fruits": "Fruits",
      "Vegetables": "Vegetables",
      "Ribeye": "Ribeye",
      "Striploin": "Striploin",
      "Tenderloin": "Tenderloin",
      "Bacon": "Bacon",
      "Loins": "Loins",
      "Hams": "Hams",
      "Boneless Breast": "Boneless Breast",
      "Wings": "Wings",
      "Whole Broilers": "Whole Broilers",
      "Butter": "Butter",
      "Cheddar": "Cheddar",
      "Milk": "Milk",
      "Apples": "Apples",
      "Grapes": "Grapes",
      "Strawberries": "Strawberries",
      "Lettuce": "Lettuce",
      "Tomatoes": "Tomatoes",
      "Onions": "Onions",
      "Food": "Food",
      "Fuel": "Fuel",
      "Energy": "Energy",
      "Linens": "Linens",
      "Maintenance": "Maintenance",
      "Services": "Services",
      "Wine": "Wine",
      "Spirits": "Spirits",
      "Premium Wine": "Premium Wine",
      "Investment Wine": "Investment Wine",
      "Food Ingredients": "Food Ingredients",
      "Packaging": "Packaging",
      "Meat": "Meat"
    },
    "schedule": {
      "Hourly": "Hourly",
      "Daily": "Daily",
      "Monthly": "Monthly",
      "Real-time": "Real-time",
      "Intraday": "Intraday"
    },
    "region": {
      "US Markets": "US Markets",
      "National & Regional": "National & Regional",
      "US Economic Data": "US Economic Data",
      "Global": "Global",
      "Global Fine Wine": "Global Fine Wine",
      "Global Food Supply": "Global Food Supply",
      "Regional Fuel Markets": "Regional Fuel Markets"
    },
    "trend": {
      "rising": "Rising",
      "falling": "Falling",
      "stable": "Stable"
    },
    "unit": {
      "lb": "lb",
      "cwt": "cwt",
      "bag": "bag",
      "carton": "carton"
    }
  },
  "outbound": {
    "greeting": "Hello,",
    "greetingName": "Hello {name},",
    "submit": "Submit your quote",
    "questions": "If you have questions, reply to this email.",
    "deadline": "Submission deadline: {date}",
    "inviteSubject": "You're invited to submit a quote: {title}",
    "inviteBody": "You're invited to submit a quote for {number}: {title}.",
    "submitHere": "Submit your quote here: {url}",
    "receivedSubject": "Proposal received — {label}",
    "receivedBody": "We’ve received your proposal for {label}.",
    "thanks": "Thank you for submitting your response. Our team will review it and follow up if we need anything else.",
    "draftSubject": "Request for quotation: {number} — {title}",
    "draftBody": "We would like to invite {name} to submit a quotation for {number}: {title}.",
    "responseNotification": "{name} has responded to your RFQ: {title}"
  },
  "errors": {
    "ai_invalid_json": "The generated RFQ could not be read. Please try again.",
    "ai_invalid_response": "The generated RFQ is incomplete. Please try again.",
    "award_submission_not_budgeted": "The selected offer does not match the budgeted offer.",
    "bidder_not_found": "Bidder not found.",
    "budget_line_not_found": "Budget line not found.",
    "budget_missing_current_version": "This budget has no current version.",
    "budget_not_board_approved": "The budget requires board approval.",
    "budget_not_found": "Budget not found.",
    "budget_submission_missing": "Select an offer to send to Budget.",
    "club_currency_fetch_failed": "The club currency could not be loaded.",
    "club_identity_unavailable": "Club information is unavailable.",
    "currency_mismatch": "The offer currency must match the club currency.",
    "description_required": "A description is required.",
    "draft_not_found": "Invitation draft not found.",
    "duplicate_or_invalid_bidder": "A selected bidder is invalid or duplicated.",
    "file_not_found": "File not found.",
    "file_too_large": "The file exceeds the upload size limit.",
    "file_upload_failed": "The file could not be uploaded.",
    "invalid_bidders": "Select valid bidders.",
    "invalid_budget_line_id": "Select a valid budget line.",
    "invalid_club_code": "The club could not be identified.",
    "invalid_contact_email": "Enter a valid contact email address.",
    "invalid_criteria": "Check the evaluation criteria.",
    "invalid_file_type": "This file type is not supported.",
    "invalid_limit": "The requested page size is invalid.",
    "invalid_multipart": "The upload could not be read. Select the file again.",
    "invalid_offset": "The requested page is invalid.",
    "invalid_request": "Check the form and try again.",
    "invalid_scores": "Check that the evaluation scores are within the allowed range.",
    "invalid_status": "Select a valid status.",
    "invalid_status_transition": "This status change is not allowed.",
    "invite_not_found": "Invitation not found.",
    "mailbox_changed_regenerate_drafts": "Your mailbox has changed. Generate the invitation drafts again.",
    "missing_bidder_email": "Add an email address for this bidder.",
    "missing_file": "Select a file to upload.",
    "missing_required_fields": "Complete the required fields.",
    "name_required": "A bidder name is required.",
    "need_text_required": "Describe your procurement need.",
    "need_text_too_long": "Keep the procurement need within 4,000 characters.",
    "no_updates": "No changes were provided.",
    "rate_limit_exceeded": "Too many requests. Please try again later.",
    "rate_limited": "Too many requests. Please try again later.",
    "recipient_must_match_bidder_contact": "The recipient must match the selected bidder contact.",
    "rfq_already_awarded": "This RFQ has already been awarded.",
    "rfq_already_sent_to_budget": "This RFQ has already been sent to Budget.",
    "rfq_not_accepting_submissions": "This RFQ is not accepting offers.",
    "rfq_not_awarded": "Award this RFQ before promoting its bidder.",
    "rfq_not_eligible": "This RFQ is not eligible for this action.",
    "rfq_not_found": "RFQ not found.",
    "rfq_not_sent_to_budget": "Send this RFQ to Budget first.",
    "scoring_template_not_found": "Scoring template not found.",
    "send_in_progress": "This email is already being sent.",
    "send_reconciliation_pending": "Delivery is being checked. Please wait before retrying.",
    "send_reconciliation_required": "Delivery must be checked before retrying.",
    "submission_failed": "The offer could not be submitted. Please try again.",
    "submission_not_found": "Offer not found.",
    "submission_rfq_mismatch": "This offer belongs to a different RFQ.",
    "weights_must_sum_to_100": "Evaluation weights must total 100%."
  },
  "newActions": {
    "review": "Schedule performance review meeting",
    "research": "Research alternative bidders",
    "negotiate": "Prepare negotiation strategy",
    "terms": "Review contract terms and conditions"
  },
  "contractDefault": "{rfq} Awarded Contract",
  "dayValue": "{count} day",
  "showingOne": "Showing {start}–{end} of {total} bidder",
  "emailSentOne": "Email sent successfully to {count} recipient!"
};
